<script setup lang="ts">

import { beautyPhoneNumber } from '@/utils/helper.ts'
import { computed, ref } from 'vue'
interface Props {
  data: object | string | number
  cellConfig: Object,
  tableConfig?: Object,
}

const props = defineProps<Props>()
const counter = computed(() => {
  console.log(13, props)
  return props.data?.length || 0
})

const openState = ref<boolean>(false)

const handleClickCounter = () => {
  openState.value = !openState.value
}

const handleClickOutside = () => {
  openState.value = false
}
</script>

<template>
  <div class="table-cell">
    <span class="counter">{{counter || ''}}</span>
    <div class="model-detail">
      <template v-for="(item, index) in data" :key="`ward_item_${index}`">
        <span class="ward-item">{{item}}</span>
      </template>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .counter {
    display: inline-block;
    padding: 5px 10px;
    background: #f3f3f3;
    border-radius: 50%;
    color: #373737;
    &:empty{
      display: none;
    }
  }
  .table-cell{
    position: relative;
    .model-detail{
      display: none;
    }
    &:hover {
      .model-detail {
        display: block;
        position: absolute;
        left: 10px;
        top: 10px;
        background: #fff;
        box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;
        width: 350px;
        padding: 10px;
        line-height: 30px;

        .ward-item {
          display: inline;
          margin-right: 10px;
          background: #e5faff;
          padding: 3px;
          border-radius: 3px;

          &:hover {
            background: #baf0ff;
          }
        }
      }
    }
  }
</style>
